
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic13On as ObiHydraulic13OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-13-on.js';
 
 
 

 
 export const ObiHydraulic13On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-13-on',
   elementClass: ObiHydraulic13OnElement,
   events: {
     
   }
  });
 
 